import { useTranslation } from 'react-i18next'

import { formatDate } from '#/shared/lib/format'

import type { CarrierRequestDates } from '../model/types'

interface RequestPickupDeliveryProps {
  dates: CarrierRequestDates
}

export function RequestPickupDelivery({ dates }: RequestPickupDeliveryProps) {
  const { t } = useTranslation()
  return (
    <div className="flex flex-col gap-2 text-sm">
      <DateRow
        label={t('carrierRequests.pickup')}
        value={dates.pickupAt ? formatDate(dates.pickupAt) : undefined}
      />
      <DateRow
        label={t('carrierRequests.delivery')}
        value={dates.deliveryAt ? formatDate(dates.deliveryAt) : undefined}
      />
    </div>
  )
}

function DateRow({ label, value }: { label: string; value?: string }) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm font-medium text-gray-900">{value ?? '—'}</span>
      <span className="text-xs text-gray-500">·</span>
      <span className="text-xs text-gray-500">{label}</span>
    </div>
  )
}
